"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChatEvents = function () {
    function ChatEvents() {
        _classCallCheck(this, ChatEvents);

        this.onNewMeetingReceived = null;
        this.onMeetingClosed = null;
        this.onMeetingLeft = null;
        this.onMeetingEnded = null;
        this.onMeetingJoined = null;
        this.onMeetingUserInvite = null;
        this.onNewVisitorArrived = null;
        this.onSystemInvite = null;
        this.onUserActivity = null;
        this.onNetworkStatusChange = null;

        this.setChatEventsCallback = this.setChatEventsCallback.bind(this);
    }

    _createClass(ChatEvents, [{
        key: "setChatEventsCallback",
        value: function setChatEventsCallback(options) {

            if (options.onNewMeetingReceivedCallback) {
                this.onNewMeetingReceived = options.onNewMeetingReceivedCallback;
            }

            if (options.onMeetingClosedCallback) {
                this.onMeetingClosed = options.onMeetingClosedCallback;
            }

            if (options.onMeetingLeftCallback) {
                this.onMeetingLeft = options.onMeetingLeftCallback;
            }

            if (options.onMeetingEndedCallback) {
                this.onMeetingEnded = options.onMeetingEndedCallback;
            }

            if (options.onMeetingJoinedCallback) {
                this.onMeetingJoined = options.onMeetingJoinedCallback;
            }

            if (options.onMeetingUserInviteCallback) {
                this.onMeetingUserInvite = options.onMeetingUserInviteCallback;
            }

            if (options.onNewVisitorArrivedCallback) {
                this.onNewVisitorArrived = options.onNewVisitorArrivedCallback;
            }

            if (options.onSystemInviteCallback) {
                this.onSystemInvite = options.onSystemInviteCallback;
            }

            if (options.onUserActivityCallback) {
                this.onUserActivity = options.onUserActivityCallback;
            }

            if (options.onNetworkStatusChangeCallback) {
                this.onNetworkStatusChange = options.onNetworkStatusChangeCallback;
            }
        }
    }]);

    return ChatEvents;
}();

exports.default = new ChatEvents();


// WEBPACK FOOTER //
// ../chat/lib/services/chatEvents.js